import { DateTime } from 'luxon';
import { EmptyVehicleSectionDisclaimer } from '@/reports/shared/ReportSection/EmptyVehicleSectionDisclaimer/EmptyVehicleSectionDisclaimer';
import { ReportSection } from '@/reports/shared/ReportSection/ReportSection';
import { InspectionEvents } from '@/reports/types/vehicles';
import { Card, Text, Table, Box } from '@/theme/index';

/**
 * A component that displays professional inspection events for a vehicle.
 * @param {VehicleInspectionProps} props - The props for the component.
 * @returns {JSX.Element} - The JSX element representing the VehicleInspection component.
 */

/**
 * Props for the VehicleInspection component.
 */
export interface VehicleInspectionProps {
  /**
   * The inspection events for the vehicle.
   */
  inspectionEvents: InspectionEvents | [] | null;
}

export function VehicleInspections({
  inspectionEvents,
}: VehicleInspectionProps) {
  const inspectionCount = inspectionEvents?.length;
  return (
    <ReportSection
      showTopBar
      title="Inspections"
      hasContent={Boolean(inspectionCount && inspectionCount > 0)}
      sectionId="vehicle-inspections"
      customEmptyText={<EmptyVehicleSectionDisclaimer title="inspection" />}
    >
      {inspectionEvents?.map((inspectionEvent, index) => {
        let inspectionDate = 'N/A';
        const full = inspectionEvent?.submitted_at?.full;
        inspectionDate = full
          ? DateTime.fromFormat(full, 'yyyy-MM-dd HH:mm:ss').toFormat(
              'MM/dd/yyyy'
            )
          : 'N/A';

        return (
          <Card key={index} variant="outlined">
            <Box display="flex">
              <Text variant="h3" fontWeight={300}>
                Inspection Reported on
              </Text>{' '}
              <Text variant="h3" ml={0.8}>
                {inspectionDate}
              </Text>
            </Box>
            <Table
              sx={{
                '.MuiTableCell-root': {
                  width: '50%',
                },
              }}
              className="striped flipped"
              rows={[
                [
                  'Overall Inspection Report',
                  inspectionEvent.overall_inspection_result || 'N/A',
                ],
                ['Type', inspectionEvent.type || 'N/A'],
                ['Odometer', inspectionEvent?.odometer?.toString() || 'N/A'],
              ]}
            />
          </Card>
        );
      })}
    </ReportSection>
  );
}
